import { Injectable, Component, Input, NgModule } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

function BreadcrumbComponent_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbComponent_li_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.navigateTo("/"); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const url_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(url_r1);
} }
function BreadcrumbComponent_li_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function BreadcrumbComponent_li_1_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const url_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.navigateTo(url_r1); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const url_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.friendlyName(url_r1));
} }
function BreadcrumbComponent_li_1_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const url_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.friendlyName(url_r1));
} }
function BreadcrumbComponent_li_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.friendlyName("/"));
} }
const _c0 = function (a0, a1) { return { "breadcrumb-item": a0, "active": a1 }; };
function BreadcrumbComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 1);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_li_1_a_1_Template, 2, 1, "a", 2);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_li_1_a_2_Template, 2, 1, "a", 2);
    ɵngcc0.ɵɵtemplate(3, BreadcrumbComponent_li_1_span_3_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵtemplate(4, BreadcrumbComponent_li_1_span_4_Template, 2, 1, "span", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const url_r1 = ctx.$implicit;
    const last_r2 = ctx.last;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c0, ctx_r0.useBootstrap, last_r2));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2 && url_r1 == ctx_r0.prefix);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r2 && url_r1 != ctx_r0.prefix);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r2 && url_r1 == ctx_r0.prefix);
} }
class BreadcrumbService {
    constructor() {
        this.routesFriendlyNames = new Map();
        this.routesFriendlyNamesRegex = new Map();
        this.routesWithCallback = new Map();
        this.routesWithCallbackRegex = new Map();
        this.hideRoutes = new Array();
        this.hideRoutesRegex = new Array();
    }
    /**
     * Specify a friendly name for the corresponding route.
     *
     * @param {?} route
     * @param {?} name
     * @return {?}
     */
    addFriendlyNameForRoute(route, name) {
        this.routesFriendlyNames.set(route, name);
    }
    /**
     * Specify a friendly name for the corresponding route matching a regular expression.
     *
     * @param {?} routeRegex
     * @param {?} name
     * @return {?}
     */
    addFriendlyNameForRouteRegex(routeRegex, name) {
        this.routesFriendlyNamesRegex.set(routeRegex, name);
    }
    /**
     * Specify a callback for the corresponding route.
     * When a mathing url is navigatedd to, the callback function is invoked to get the name to be displayed in the breadcrumb.
     * @param {?} route
     * @param {?} callback
     * @return {?}
     */
    addCallbackForRoute(route, callback) {
        this.routesWithCallback.set(route, callback);
    }
    /**
     * Specify a callback for the corresponding route matching a regular expression.
     * When a mathing url is navigatedd to, the callback function is invoked to get the name to be displayed in the breadcrumb.
     * @param {?} routeRegex
     * @param {?} callback
     * @return {?}
     */
    addCallbackForRouteRegex(routeRegex, callback) {
        this.routesWithCallbackRegex.set(routeRegex, callback);
    }
    /**
     * Show the friendly name for a given route (url). If no match is found the url (without the leading '/') is shown.
     *
     * @param {?} route
     * @return {?}
     */
    getFriendlyNameForRoute(route) {
        let /** @type {?} */ routeEnd = route.substr(route.lastIndexOf('/') + 1, route.length);
        let /** @type {?} */ name = routeEnd;
        this.routesFriendlyNames.forEach((value, key, map) => {
            if (key === route) {
                name = value;
            }
        });
        this.routesFriendlyNamesRegex.forEach((value, key, map) => {
            if (new RegExp(key).exec(route)) {
                name = value;
            }
        });
        this.routesWithCallback.forEach((value, key, map) => {
            if (key === route) {
                name = value(routeEnd);
            }
        });
        this.routesWithCallbackRegex.forEach((value, key, map) => {
            if (new RegExp(key).exec(route)) {
                name = value(routeEnd);
            }
        });
        return name;
    }
    /**
     * Specify a route (url) that should not be shown in the breadcrumb.
     * @param {?} route
     * @return {?}
     */
    hideRoute(route) {
        if (this.hideRoutes.indexOf(route) === -1) {
            this.hideRoutes.push(route);
        }
    }
    /**
     * Specify a route (url) regular expression that should not be shown in the breadcrumb.
     * @param {?} routeRegex
     * @return {?}
     */
    hideRouteRegex(routeRegex) {
        if (this.hideRoutesRegex.indexOf(routeRegex) === -1) {
            this.hideRoutesRegex.push(routeRegex);
        }
    }
    /**
     * Returns true if a route should be hidden.
     * @param {?} route
     * @return {?}
     */
    isRouteHidden(route) {
        let /** @type {?} */ hide = this.hideRoutes.indexOf(route) > -1;
        this.hideRoutesRegex.forEach((value) => {
            if (new RegExp(value).exec(route)) {
                hide = true;
            }
        });
        return hide;
    }
}
BreadcrumbService.ɵfac = function BreadcrumbService_Factory(t) { return new (t || BreadcrumbService)(); };
BreadcrumbService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbService, factory: BreadcrumbService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * This component shows a breadcrumb trail for available routes the router can navigate to.
 * It subscribes to the router in order to update the breadcrumb trail as you navigate to a component.
 */
class BreadcrumbComponent {
    /**
     * @param {?} router
     * @param {?} breadcrumbService
     */
    constructor(router, breadcrumbService) {
        this.router = router;
        this.breadcrumbService = breadcrumbService;
        this.useBootstrap = true;
        this.prefix = '';
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._urls = new Array();
        if (this.prefix.length > 0) {
            this._urls.unshift(this.prefix);
        }
        if (this.router.navigated) {
            this._urls.length = 0; //Fastest way to clear out array
            this.generateBreadcrumbTrail(this.router.routerState.snapshot.url);
        }
        this._routerSubscription = this.router.events.subscribe((navigationEnd) => {
            if (navigationEnd instanceof NavigationEnd) {
                this._urls.length = 0; //Fastest way to clear out array
                this.generateBreadcrumbTrail(navigationEnd.urlAfterRedirects ? navigationEnd.urlAfterRedirects : navigationEnd.url);
            }
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!this._urls) {
            return;
        }
        this._urls.length = 0;
        this.generateBreadcrumbTrail(this.router.url);
    }
    /**
     * @param {?} url
     * @return {?}
     */
    generateBreadcrumbTrail(url) {
        if (!this.breadcrumbService.isRouteHidden(url)) {
            //Add url to beginning of array (since the url is being recursively broken down from full url to its parent)
            this._urls.unshift(url);
        }
        if (url.lastIndexOf('/') > 0) {
            this.generateBreadcrumbTrail(url.substr(0, url.lastIndexOf('/'))); //Find last '/' and add everything before it as a parent route
        }
        else if (this.prefix.length > 0) {
            this._urls.unshift(this.prefix);
        }
    }
    /**
     * @param {?} url
     * @return {?}
     */
    navigateTo(url) {
        this.router.navigateByUrl(url);
    }
    /**
     * @param {?} url
     * @return {?}
     */
    friendlyName(url) {
        return !url ? '' : this.breadcrumbService.getFriendlyNameForRoute(url);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._routerSubscription.unsubscribe();
    }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(BreadcrumbService)); };
BreadcrumbComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["breadcrumb"]], inputs: { useBootstrap: "useBootstrap", prefix: "prefix" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[3, "ngClass", 4, "ngFor", "ngForOf"], [3, "ngClass"], ["role", "button", 3, "click", 4, "ngIf"], [4, "ngIf"], ["role", "button", 3, "click"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul");
        ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_li_1_Template, 5, 8, "li", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("breadcrumb", ctx.useBootstrap);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx._urls);
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgClass, ɵngcc2.NgIf], encapsulation: 2 });
/** @nocollapse */
BreadcrumbComponent.ctorParameters = () => [
    { type: Router, },
    { type: BreadcrumbService, },
];
BreadcrumbComponent.propDecorators = {
    "useBootstrap": [{ type: Input },],
    "prefix": [{ type: Input },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'breadcrumb',
                template: `
        <ul [class.breadcrumb]="useBootstrap">
            <li *ngFor="let url of _urls; let last = last" [ngClass]="{'breadcrumb-item': useBootstrap, 'active': last}"> <!-- disable link of last item -->
                <a role="button" *ngIf="!last && url == prefix" (click)="navigateTo('/')">{{url}}</a>
                <a role="button" *ngIf="!last && url != prefix" (click)="navigateTo(url)">{{friendlyName(url)}}</a>
                <span *ngIf="last">{{friendlyName(url)}}</span>
                <span *ngIf="last && url == prefix">{{friendlyName('/')}}</span>
            </li>
        </ul>
    `
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: BreadcrumbService }]; }, { useBootstrap: [{
            type: Input
        }], prefix: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgBreadcrumbModule {
}
NgBreadcrumbModule.ɵfac = function NgBreadcrumbModule_Factory(t) { return new (t || NgBreadcrumbModule)(); };
NgBreadcrumbModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgBreadcrumbModule });
NgBreadcrumbModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [BreadcrumbService], imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgBreadcrumbModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    BreadcrumbComponent
                ],
                exports: [
                    BreadcrumbComponent
                ],
                providers: [BreadcrumbService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgBreadcrumbModule, { declarations: function () { return [BreadcrumbComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [BreadcrumbComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgBreadcrumbModule, BreadcrumbComponent, BreadcrumbService };

